/** Shown when the URL names no company, or one that does not exist. */
const CompanyNotFoundPage = () => (
  <main className="flex min-h-screen items-center justify-center bg-gray-100 p-6">
    <div role="alert" className="max-w-md rounded-2xl bg-white p-8 text-center shadow-sm">
      <p className="text-sm font-semibold text-orange-600">404</p>
      <h1 className="mt-2 text-2xl font-bold text-gray-900">
        We couldn't find this careers page
      </h1>
      <p className="mt-4 text-gray-600">
        Check the link you were given. Careers pages look like
        jobs.redstonehr.com/your-company.
      </p>
    </div>
  </main>
);

export default CompanyNotFoundPage;
